import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ConsentProvider } from "./context/ConsentContext";
import { Toaster } from "./components/ui/sonner";
import { CookieConsent } from "./components/CookieConsent";
import { ChatWidget } from "./components/ChatWidget";
import { ScrollToTop } from "./components/ScrollToTop";
import { VisitTracker } from "./components/VisitTracker";
import Home from "./pages/Home";
import VehicleDetails from "./pages/VehicleDetails";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalInfo from "./pages/LegalInfo";
import CookiePolicy from "./pages/CookiePolicy";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminBlog from "./pages/AdminBlog";
import LocalLanding from "./pages/LocalLanding";
import AdminAnalytics from "./pages/AdminAnalytics";

function App() {
  useEffect(() => {
    const TITLE = "STAND LF — Automóveis em São João de Ovar";
    const setTitle = () => { document.title = window.__seoTitle || TITLE; };
    setTitle();
    const timers = [setTimeout(setTitle, 800), setTimeout(setTitle, 2000), setTimeout(setTitle, 4000)];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="App">
      <ConsentProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <VisitTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/viatura/:id" element={<VehicleDetails />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
              <Route path="/resolucao-litigios" element={<LegalInfo />} />
              <Route path="/politica-cookies" element={<CookiePolicy />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/carros-usados-ovar" element={<LocalLanding cityKey="ovar" />} />
              <Route path="/carros-usados-aveiro" element={<LocalLanding cityKey="aveiro" />} />
              <Route path="/automoveis-usados-porto" element={<LocalLanding cityKey="porto" />} />
            </Routes>
            <CookieConsent />
            <ChatWidget />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ConsentProvider>
    </div>
  );
}

export default App;
